<button id="click-dns-cookie" class="click-dns-cookie">
    Do Not Sell or Share My Personal Information
</button>